<div class="row page-header d-flex justify-content-center mx-sm-1 py-4">
  <div class="col-12 col-lg-11 col-xl-10">
    <div class="d-flex justify-content-between mb-2 align-items-start px-sm-0">
      <h2 class="page-title">
        {{ "users" | transloco }}
      </h2>

      <div class="flex-wrap justify-content-end d-none d-sm-flex">
        <p-splitButton
          label="{{ 'actions' | transloco }}"
          [model]="items"
          class="ms-2 p-button-sm"
        ></p-splitButton>

        <p-button
          label="{{ 'add' | transloco }}"
          icon="pi pi-plus"
          class="ms-2"
          [routerLink]="['/users/new']"
        />
        @if (activeTenant && (auth.isTenantAdmin$ | async)) {
          <app-import-export
            class="ms-2 d-none d-md-block"
            filenamePrefix="users"
            [importFactory]="importFactory"
            [exportFactory]="exportFactory"
            (outputError)="showError($event)"
            (submitImport)="submitImport($event)"
            [waitingForImportResponseSet]="waitingForImportResponse$"
          ></app-import-export>
        }
      </div>
    </div>

    @if (hasErrors) {
      <app-error-alert
        class="mt-3 px-0"
        title="{{ 'couldNotImportUsers' | transloco }}"
        [errors]="submitErrors"
      ></app-error-alert>
    }

    <app-users-list
      style="width: 100%"
      [innerWidth]="innerWidth"
      [users]="users"
      [clearSelectedUsers]="emptySelectedUsers"
      [isDeleteDisabled]="!(auth.isSuperAdmin$ | async)"
      (delete)="handleDeleteClick($event)"
      (onUserSelection)="handleUserSelection($event)"
    ></app-users-list>

    <p-confirmDialog [style]="{ width: '50vw' }">
      <ng-template pTemplate="footer">
        <button
          pButton
          type="button"
          label="{{ 'yes' | transloco }}"
          class="p-button-secondary"
          (click)="deleteSelectedUsers()"
        ></button>

        <button
          pButton
          type="button"
          label="{{ 'no' | transloco }}"
          (click)="confirmationService.close()"
        ></button>
      </ng-template>
    </p-confirmDialog>
  </div>
</div>

<p-button
  class="d-block d-sm-none mobile-add-button"
  icon="pi pi-plus"
  [routerLink]="['new']"
/>
